/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_OverdueInputs */

const en_ui_overdue = /** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`overdue`)
};

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const ar_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const he_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const ur_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const es_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const fr_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const de_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const pt_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const hi_ui_overdue = en_ui_overdue;

/** @type {(inputs: Ui_OverdueInputs) => LocalizedString} */
const bn_ui_overdue = en_ui_overdue;

/**
* | output |
* | --- |
* | "overdue" |
*
* @param {Ui_OverdueInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_overdue = /** @type {((inputs?: Ui_OverdueInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_OverdueInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_overdue(inputs)
	if (locale === "he") return he_ui_overdue(inputs)
	if (locale === "ur") return ur_ui_overdue(inputs)
	if (locale === "es") return es_ui_overdue(inputs)
	if (locale === "fr") return fr_ui_overdue(inputs)
	if (locale === "de") return de_ui_overdue(inputs)
	if (locale === "pt") return pt_ui_overdue(inputs)
	if (locale === "hi") return hi_ui_overdue(inputs)
	if (locale === "bn") return bn_ui_overdue(inputs)
	return /** @type {LocalizedString} */ ("overdue")
});